<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'pages.audit.modalTitle' | translate }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body map-modal-body">
    <h5 class="audit-entry-title">{{ 'pages.audit.changes' | translate }} {{ auditEntry.table }}</h5>
    <p class="audit-entry-changes" [innerHTML]="getChanges()"></p>
    <h5 class="author">{{ 'pages.audit.changesMadeBy' | translate }}</h5>
    <p class="author-name">{{ auditEntry.createdBy }}</p>
    <h5 class="author-date-title">{{ 'pages.audit.date' | translate }}</h5>
    <p class="author-date">{{ formatDateTime(auditEntry.createdOn, false) }}</p>
  </div>
</ng-template>
